import * as yup from 'yup';

export const defaultValues = {
  message: '',
};

export const validation = yup.object().shape({
  message: yup.string().required('Message is required'),
});
